import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ label, name, size }) => (
	<>
		<i
			className={`ddc-icon ddc-icon-${name} ddc-font-size-${size} align-middle pointer-events-none`}
			aria-hidden="true"
		/>
		<span className="pl-2 align-middle pointer-events-none">{label}</span>
	</>
);

Icon.propTypes = {
	label: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	size: PropTypes.string.isRequired
};

export default Icon;
